// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets//event.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc {
  background-color: white !important;
  font-family: "IBM Plex Sans" !important;
  font-size: 0.75rem !important;
}

.fc-button {
  text-transform: capitalize !important;
}
.customTooltip {
  background-color: "white";
  color: #6e7dab !important;
  border: "1px solid black";
  padding: 8px;
}
.customArrow {
  color: "black";
}

.fc-button-primary {
  color: #6e7dab !important;
  background-color: white !important;
  border-color: #6e7dab !important;
  font-size: 0.875rem !important;
  padding: 0.4rem 1rem !important;
  font-weight: 600 !important;
}

.fc-button-primary:hover {
  color: #6e7dab !important;
  background-color: #6e7dab0a !important;
}

.fc-button-primary:focus {
  background-color: #6e7dab !important;
  color: white !important;
  box-shadow: none !important;
}

.fc-today-button,
.fc-today-button:hover {
  background-color: rgba(110, 125, 171, 1) !important;
  color: #ffffff !important;
  border: none !important;
}

.fc-daygrid-event-dot {
  display: none;
}

.fc-toolbar-title {
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: rgba(110, 125, 171, 1) !important;
  font-family: "IBM Plex Sans", sans-serif !important;
}

.fc-prev-button,
.fc-next-button {
  background-color: white;
  display: inline-block !important;
  border-radius: 60px !important;
  padding: 0.5em 0.5em !important;
}

.fc table th {
  background-color: #f7f7ff;
}

.fc table tbody {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.fc-scrollgrid-sync-inner {
  min-height: 47px !important;
}

a.fc-col-header-cell-cushion {
  font-size: 0.875rem;
  color: #0e0a42 !important;
  font-weight: 600 !important;
  font-family: "IBM Plex Sans", sans-serif !important;
}

th div.fc-scrollgrid-sync-inner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fc-day-today {
  background-color: #f7f7ff !important;
}

@media screen and (max-width: 768px) {
  .fc .fc-toolbar.fc-header-toolbar {
    margin-bottom: 1.5em;
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
}

.fc-daygrid-dot-event .fc-event-title {
  font-weight: 400 !important;
  font-family: "IBM Plex Sans";
  color: rgba(14, 10, 66, 1) !important;
}

.fc-dayGridMonth-button.fc-button.fc-button-primary:active
  .fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active {
  border: none;
  color: #ffffff;
}

.fc.fc-button-primary:not(:disabled):active,
.fc.fc-button-primary:not(:disabled).fc-button-active:active {
  border: 2px solid #6e7dab;
  color: #000000 !important;
}

.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active:focus-visible {
  border: 2px solid #6e7dab;
}

.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active:active {
  border: 2px solid #6e7dab;
}

.fc-event-main-frame {
  color: rgba(14, 10, 66, 1) !important;
  font-weight: 400;
}

.fc-timegrid-slot-minor {
  border: none !important;
}

td[data-time\$=":30:00"] {
  border: none !important;
}

.fc-event-time {
  font: bold 13px !important;
  letter-spacing: 0.01px !important;
  color: #424242 !important;
}

.fc-non-business {
  background: #e0e0e0 !important;
  opacity: 0.5;
}

.fc-timegrid-col.fc-day {
  padding: 0 1px;
}

.fc-timegrid-slot-label-cushion {
  margin-right: 3px;
  margin-top: 5px;
}

table.fc-agenda-slots td.fc-widget-content {
  border-right: 1px #ddd solid;
}

.slot-label-style {
  background: pink !important;
  border: solid 1px black !important;
}

.fc-toolbar-chunk {
  padding-right: 15px;
}

.fc-scrollgrid-section-header .fc-scroller {
  overflow: hidden !important;
}

.audit-entry {
  padding-left: 1.5rem;
  background-color: #e0dede !important;
  border: none;
  font-weight: 400 !important;
  font-family: "IBM Plex Sans";
  color: rgba(14, 10, 66, 1) !important;
  font-size: 14px !important;
  /* margin-top: 5px !important; */
  position: relative !important;
}

.audit-entry-new {
  padding-left: 1.5rem;
  /* background-color: #e0dede !important; */
  border: none;
  font-weight: 400 !important;
  font-family: "IBM Plex Sans";
  /* color: rgba(14, 10, 66, 1) !important; */
  font-size: 14px !important;
  margin-top: 5px !important;
  position: relative !important;
}

@media screen and (max-width: 768px) {
  .audit-entry {
    background-color: inherit !important;
  }
  /* .audit-entry-new {
    background-color: inherit !important;
  } */
}

.audit-entry::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  left: 0;
}

.audit-entry-new::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  left: 0;
}

.audit-entry:focus {
  background-color: none !important;
}

/* .audit-entry-new:focus {
  background-color: none !important;
} */

.fc-timegrid-event-harness-inset .fc-timegrid-event {
  box-shadow: none !important;
}
.red {
  background-color: red;
}

.blue {
  background-color: blue;
}

.green {
  background-color: green;
}

.audit-report-wrapper {
  width: 100%;
  height: 280px;
  overflow: auto;
}

/* Style for medium screens */
@media screen and (min-width: 768px) {
  .audit-report-wrapper {
    height: 350px;
  }
}

/* Style for large screens */
@media screen and (min-width: 1200px) {
  .audit-report-wrapper {
    height: 600px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditHomePage/AuditReport/styles.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,mDAAmD;EACnD,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;;EAEE,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;EACrC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;;KAEG;AACL;;AAEA;EACE,gDAA+B;EAC/B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,gDAA+B;EAC/B,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".fc {\n  background-color: white !important;\n  font-family: \"IBM Plex Sans\" !important;\n  font-size: 0.75rem !important;\n}\n\n.fc-button {\n  text-transform: capitalize !important;\n}\n.customTooltip {\n  background-color: \"white\";\n  color: #6e7dab !important;\n  border: \"1px solid black\";\n  padding: 8px;\n}\n.customArrow {\n  color: \"black\";\n}\n\n.fc-button-primary {\n  color: #6e7dab !important;\n  background-color: white !important;\n  border-color: #6e7dab !important;\n  font-size: 0.875rem !important;\n  padding: 0.4rem 1rem !important;\n  font-weight: 600 !important;\n}\n\n.fc-button-primary:hover {\n  color: #6e7dab !important;\n  background-color: #6e7dab0a !important;\n}\n\n.fc-button-primary:focus {\n  background-color: #6e7dab !important;\n  color: white !important;\n  box-shadow: none !important;\n}\n\n.fc-today-button,\n.fc-today-button:hover {\n  background-color: rgba(110, 125, 171, 1) !important;\n  color: #ffffff !important;\n  border: none !important;\n}\n\n.fc-daygrid-event-dot {\n  display: none;\n}\n\n.fc-toolbar-title {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  color: rgba(110, 125, 171, 1) !important;\n  font-family: \"IBM Plex Sans\", sans-serif !important;\n}\n\n.fc-prev-button,\n.fc-next-button {\n  background-color: white;\n  display: inline-block !important;\n  border-radius: 60px !important;\n  padding: 0.5em 0.5em !important;\n}\n\n.fc table th {\n  background-color: #f7f7ff;\n}\n\n.fc table tbody {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.fc-scrollgrid-sync-inner {\n  min-height: 47px !important;\n}\n\na.fc-col-header-cell-cushion {\n  font-size: 0.875rem;\n  color: #0e0a42 !important;\n  font-weight: 600 !important;\n  font-family: \"IBM Plex Sans\", sans-serif !important;\n}\n\nth div.fc-scrollgrid-sync-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.fc-day-today {\n  background-color: #f7f7ff !important;\n}\n\n@media screen and (max-width: 768px) {\n  .fc .fc-toolbar.fc-header-toolbar {\n    margin-bottom: 1.5em;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n}\n\n.fc-daygrid-dot-event .fc-event-title {\n  font-weight: 400 !important;\n  font-family: \"IBM Plex Sans\";\n  color: rgba(14, 10, 66, 1) !important;\n}\n\n.fc-dayGridMonth-button.fc-button.fc-button-primary:active\n  .fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active {\n  border: none;\n  color: #ffffff;\n}\n\n.fc.fc-button-primary:not(:disabled):active,\n.fc.fc-button-primary:not(:disabled).fc-button-active:active {\n  border: 2px solid #6e7dab;\n  color: #000000 !important;\n}\n\n.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active:focus-visible {\n  border: 2px solid #6e7dab;\n}\n\n.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active:active {\n  border: 2px solid #6e7dab;\n}\n\n.fc-event-main-frame {\n  color: rgba(14, 10, 66, 1) !important;\n  font-weight: 400;\n}\n\n.fc-timegrid-slot-minor {\n  border: none !important;\n}\n\ntd[data-time$=\":30:00\"] {\n  border: none !important;\n}\n\n.fc-event-time {\n  font: bold 13px !important;\n  letter-spacing: 0.01px !important;\n  color: #424242 !important;\n}\n\n.fc-non-business {\n  background: #e0e0e0 !important;\n  opacity: 0.5;\n}\n\n.fc-timegrid-col.fc-day {\n  padding: 0 1px;\n}\n\n.fc-timegrid-slot-label-cushion {\n  margin-right: 3px;\n  margin-top: 5px;\n}\n\ntable.fc-agenda-slots td.fc-widget-content {\n  border-right: 1px #ddd solid;\n}\n\n.slot-label-style {\n  background: pink !important;\n  border: solid 1px black !important;\n}\n\n.fc-toolbar-chunk {\n  padding-right: 15px;\n}\n\n.fc-scrollgrid-section-header .fc-scroller {\n  overflow: hidden !important;\n}\n\n.audit-entry {\n  padding-left: 1.5rem;\n  background-color: #e0dede !important;\n  border: none;\n  font-weight: 400 !important;\n  font-family: \"IBM Plex Sans\";\n  color: rgba(14, 10, 66, 1) !important;\n  font-size: 14px !important;\n  /* margin-top: 5px !important; */\n  position: relative !important;\n}\n\n.audit-entry-new {\n  padding-left: 1.5rem;\n  /* background-color: #e0dede !important; */\n  border: none;\n  font-weight: 400 !important;\n  font-family: \"IBM Plex Sans\";\n  /* color: rgba(14, 10, 66, 1) !important; */\n  font-size: 14px !important;\n  margin-top: 5px !important;\n  position: relative !important;\n}\n\n@media screen and (max-width: 768px) {\n  .audit-entry {\n    background-color: inherit !important;\n  }\n  /* .audit-entry-new {\n    background-color: inherit !important;\n  } */\n}\n\n.audit-entry::before {\n  content: url(assets//event.png);\n  position: absolute;\n  left: 0;\n}\n\n.audit-entry-new::before {\n  content: url(assets//event.png);\n  position: absolute;\n  left: 0;\n}\n\n.audit-entry:focus {\n  background-color: none !important;\n}\n\n/* .audit-entry-new:focus {\n  background-color: none !important;\n} */\n\n.fc-timegrid-event-harness-inset .fc-timegrid-event {\n  box-shadow: none !important;\n}\n.red {\n  background-color: red;\n}\n\n.blue {\n  background-color: blue;\n}\n\n.green {\n  background-color: green;\n}\n\n.audit-report-wrapper {\n  width: 100%;\n  height: 280px;\n  overflow: auto;\n}\n\n/* Style for medium screens */\n@media screen and (min-width: 768px) {\n  .audit-report-wrapper {\n    height: 350px;\n  }\n}\n\n/* Style for large screens */\n@media screen and (min-width: 1200px) {\n  .audit-report-wrapper {\n    height: 600px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
